import React, { useState, useEffect } from 'react';
import { CategoryTabs } from './../../../../components/Admin/Category/CategoryTabs'
import { useAllCategoryData } from '../../../../hooks/UseCategoryData';
import { CategorySearch } from './../../../../components/Admin/Category/CategorySearch';
import { useParams } from 'react-router-dom';
import api from '../../../../services/apiServices';

//
// src/pages/Admin/Views/CategoryManagement/CategoryDetailPage.jsx

export default function CategoryDetailPage() {
  const { locale, id, tab } = useParams();
  
  const { categories, loading } = useAllCategoryData();
  //const categoriesLoaded = categories.length > 0;
  const [qna, setQna] = useState([]);
  const category = id ? categories.find(cat => Number(cat.id) === Number(id)) : null;
  
  const categoryId = category ? category.id : null;

  useEffect(() => {
    const fetchQnA = async () => {
      if (!categoryId) return;
      //console.log("🧩 category resolved from id:", category);
      console.log("🔄 Fetching QnA for category:", categoryId);
      try {
        const response = await api.get(`/admin/categories/cat-qna/category/${categoryId}`,{
          params: { locale },
        });
        setQna(response.data);
      } catch (err) {
        console.error("Failed to fetch QnA:", err);
        setQna([]);
      }
    };
    fetchQnA();
  }, [categoryId]);

  console.log('🔁 Params → id:', id, 'tab:', tab);
  console.log('📦 categories:', categories);
  console.log('📦 QnA:', qna);


  return (
    <div className="p-6">
      {/*<LocaleSelector />*/}
      
      {/* --- MODIFIED LOGIC --- */}
      {/* Only show search if a locale is selected */}
      {locale && (
        <div className="mb-4">
          <CategorySearch locale={locale} categoryList={categories}/>
        </div>
      )}

      {loading ? (
        <p className="text-gray-600">Loading categories...</p>
      ) : !locale ? ( // <-- CHANGED
        // If no locale, prompt user
        <p className="text-gray-600">Please select a locale to begin.</p>
      ) : (
        // Locale is selected, proceed as normal
        <>
          {category ? (
            <h1 className="text-2xl font-bold mb-4">Category: {category.name}</h1>
          ) : (
            <p className="text-gray-600 mb-4">Search for a category to get started or create a new one.</p>
          )}
          <CategoryTabs locale={locale} category={category} categoryList={categories} questionList={qna} />
        </>
      )}
      {/* --- END MODIFIED LOGIC --- */}
    </div>
  );
}
